import { useQuery } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { getPhoneNumberByCarrier } from 'services';
import { useSnackbar } from 'hooks';
import { PHONE_NUMBER_BY_CARRIER } from '../constants';

const errorMessage = 'Something went wrong, please try again later.';

export function useGetPhoneNumberByCarrier(carrier: string) {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const setSnackbar = useSnackbar();

  return useQuery([PHONE_NUMBER_BY_CARRIER], {
    queryFn: () => getPhoneNumberByCarrier(corpAcctNbr, carrier),
    enabled: !!corpAcctNbr,
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      setSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
        severity: 'error',
      });
    },
  });
}
